import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import { FiX } from 'react-icons/fi';
import PropTypes from 'prop-types';
import { cardExcerpt } from '~helpers/cardExcerpt';
import { renderFirstName } from '~helpers/common';
import moment from 'moment';

import VerificationBadge from '~components/verification/badge';
import Avatar from '~components/avatar';
import Stars from '~components/stars';
// import LastOnline from '~components/last-online';
// import RegisteredSince from '~components/registered-since';
// import Button from '~components/button';
import Favorite from '~components/favorite';
// import Tooltip from '~components/tooltip';

import '../style.scss';

const WorkerCard = memo(
  ({
    personId,
    className,
    stars,
    score,
    price,
    address,
    experience,
    firstName,
    profilePicture,
    verification,
    lastLogin,
    registerDate,
    isOnline,
    personalNote,
    days,
    published,
    slug,
    showViewButton = false,
    showCloseButton = false,
    onClose = () => {},
    showFavorite = false,
    isFavorite,
    isCityPage=false,
    cityName=false,
    citySlug=false,
    isHomePage=false,
    onView = () => {},
    onFavorite = () => {},
  }) => {
    const intl = useIntl();
    const truncatedDescription = cardExcerpt(personalNote);

    const fName = renderFirstName(firstName);

    return (
      <div className={cx('c-card c-card--worker', { [className]: !!className })} itemType="http://schema.org/Product">
        <meta itemProp="brand" content="Juan Pescador" />
        <meta itemProp="sku" content={personId} />
        <meta itemProp="name" content={fName} />
        {profilePicture && profilePicture.large ? <link itemProp="image" href={profilePicture.large} /> : null}
        <meta
          itemProp="description"
          content={
            personalNote ||
            intl.formatMessage(
              {
                id: 'containers.profile.seo.worker.description.default',
              },
              {
                name: fName,
                city: address?.city || address?.country,
              }
            )
          }
        />
        <div className={`c-card__inner ${!published ? 'c-card__inner_not_active' : ''}`} itemProp="offers" itemType="http://schema.org/Offer" itemScope>
          
          <Link className="c-card__inner_wrap" to={`/profile/${slug}`} {...(isHomePage ? { rel: 'nofollow' } : {})}>
            <div className="c-card__header">
              <Avatar profilePicture={profilePicture} firstName={fName} className="c-card__photo" size="large" /> 
              {/* size="thumbnail" option is also there for smaller size picture*/}
              {/* <div className="c-card__header-details"> */}
                {/* <div className="c-card__name l-truncate notranslate">
                  {fName}
                  <VerificationBadge isVerified={verification} />
                </div> */}

                {/* <div className="c-card__city">
                  {isCityPage ? (
                      <span className="c-city__name">
                        {intl.formatMessage(
                          {
                            id: 'containers.workers.seo.headline.card-subtitle', defaultMessage: 'Cleaners {city}'
                          },
                          {
                            city: cityName,
                          }
                        )}
                      </span>
                  ) : (
                    <span className="c-city__name">
                      {intl.formatMessage(
                        {
                          id: 'containers.workers.seo.headline.card-subtitle', defaultMessage: 'Cleaners {city}'
                        },
                        {
                          city: address?.city || address?.country,
                        }
                      )}
                    </span>
                  )}
                  
                </div> */}

                {/* {price && parseInt(price.amount, 10) >= 0 && price.currency ? (
                  {isHomePage && (address?.country || address?.country_code) && (
                  <div className="c-card__country">{address.country || address.country_code}</div>
                )}
                <div className="c-card__price">
                    {intl.formatMessage(
                      { id: 'components.card.price.value', defaultMessage: '{amount}' },
                      {
                        amount: intl.formatNumber(price.amount / 100, {
                          style: 'currency',
                          currency: price.currency,
                        }),
                      }
                    )}
                  </div>
                ) : null} */}
              {/* </div> */}


              {/* {showFavorite && (
                <Favorite
                  personId={personId}
                  accountType="worker"
                  isFavorite={isFavorite}
                  mode="icon"
                  onChange={onFavorite}
                  className="c-card__favorite"
                />
              )} */}
              {/* {showCloseButton && (
                <button type="button" className="c-card__close" onClick={onClose}>
                  <FiX />
                </button>
              )} */}
            </div>

            <div className="c-card__content">
              {/* SCORE */}
              {/* <div className="c-card__item">
                <div className="c-card__key">
                  {intl.formatMessage({ id: 'components.card.reviews', defaultMessage: 'Customer rating' })}
                </div>
                <div className="c-card__value c-card__score">
                  <Stars value={score?.score || 4 }  />
                  
                  {score && score.votes > 0 ? <div className="c-card__votes">({score.votes})</div> : null}
                </div>
              </div> */}

              {/* <Stars value={score?.score} disabled={!score || !score.score} />  */}

              {/* EXPERIENCE */}
              {/* <div className="c-card__item">
                <div className="c-card__key">
                  {intl.formatMessage({ id: 'components.card.experience.label', defaultMessage: 'Experience' })}
                </div>
                <div className="c-card__value">
                  {intl.formatMessage(
                    {
                      id: 'components.card.experience.value',
                      defaultMessage: '{experience, plural, =1 {# appointment} other {# appointments}}',
                    },
                    { experience: experience || 0 }
                  )}
                </div>
              </div> */}
              {/* DAYS */}
              {/* {
                days && (
                  <div className="c-card__item">
                  <div className="c-card__key">
                    {intl.formatMessage({ id: 'components.card.worker-days.label', defaultMessage: 'Possible days' })}
                  </div>
                  <div className="c-card__value">
                    {days.map(
                      (d, index) =>
                        `${intl.formatMessage({ id: `days.short.${d}` })}${index !== days.length - 1 ? ', ' : ''}`
                    )}
                  </div>
                </div>
                )
              } */}
              {/* LAST ONLINE */}
              {/* <LastOnline lastOnline={lastLogin} isOnline={isOnline} isPublished={published} registerDate={registerDate} /> */}
              {/* temp_hide */}
              {/* <div className="c-card__item">
                <div className="c-card__key">
                  {intl.formatMessage({ id: 'components.card.registered-since.label', defaultMessage: 'Registered Since' })}
                </div>
                <div className="c-card__value">
                  <RegisteredSince registerDate={registerDate} isPublished={published} isOnline={isOnline} />
                </div>
              </div> */}
              {/* LOCATION */}
              {/* <div className="c-card__item">
                <div className="c-card__key">
                  {intl.formatMessage({ id: 'components.card.location.label', defaultMessage: 'Location' })}
                </div>
                <div className="c-card__value">{[address?.city, address?.country].filter(Boolean).join(', ')}</div>
              </div> */}
              {/* PERSONAL NOTE */}
              <div className="c-card__item c-card__item--last">
                {/* <div className="c-card__key">
                  {intl.formatMessage({ id: 'components.card.personal-note.label', defaultMessage: 'Personal note' })}
                </div> */}
                <div className="c-card__name l-truncate notranslate">
                  {fName}
                  <VerificationBadge isVerified={verification} />
                </div>                
                {/* {showFavorite && (
                  <Favorite
                    personId={personId}
                    accountType="worker"
                    isFavorite={isFavorite}
                    mode="icon"
                    onChange={onFavorite}
                    className="c-card__favorite"
                  />
                )} */}

                {isHomePage && (address?.country || address?.country_code) && (
                  <div className="c-card__country">{address.country || address.country_code}</div>
                )}
                <div className="c-card__price">
                  {intl.formatMessage(
                      { id: 'components.card.price.value', defaultMessage: '{amount}' },
                      {
                        amount: intl.formatNumber(price.amount / 100, {
                          style: 'currency',
                          currency: price.currency,
                        }),
                      }
                    )}
                </div>

                {isHomePage && price?.currency && <div className="c-card__currency">{price.currency}</div>}

                <div className="c-card__value c-card__value--highlight c-card__description">{truncatedDescription}</div>
                
                {score?.score != null && score?.score > 0 && (
                  <div className="c-card__value c-card__score">
                    <Stars value={score?.score}  />                
                    <div className="c-card__votes">{score?.score}/5</div> 
                  </div>
                )}

                {/* <div className="c-testimonial__score">
                    <Stars value={stars} />
                    <div className="c-testimonial__score-value">{score}</div>
                </div> */}

              </div>

              {/* VIEW BUTTON */}
              {/* {showViewButton && (
                <Button className="c-btn c-card__button" onClick={onView}>
                  {intl.formatMessage({ id: 'components.card.view', defaultMessage: 'View' })}
                </Button>
              )} */}
            </div>
            <link itemProp="url" href={`/worker/${personId}`} />
            <meta itemProp="availability" content="https://schema.org/InStock" />
            <meta itemProp="price" content={price ? price.amount * 0.01 : null} />
            <meta itemProp="priceCurrency" content={price ? price.currency : null} />
            <meta itemProp="priceValidUntil" content={moment().add(1, 'year').endOf('year').format('YYYY-MM-DD')} />
            {score && score.score && score.votes > 0 ? (
              <div itemProp="aggregateRating" itemType="https://schema.org/AggregateRating" itemScope>
                <meta itemProp="reviewCount" content={score.votes} />
                <meta itemProp="ratingValue" content={score.score} />
              </div>
            ) : null}
          </Link>
          {showFavorite && (
            <Favorite
              personId={personId}
              accountType="worker"
              isFavorite={isFavorite}
              mode="icon"
              slug={slug}
              onChange={onFavorite}
              className="c-card__favorite"
            />
          )}
          {showCloseButton && (
            <button type="button" className="c-card__close" onClick={onClose} aria-label={intl.formatMessage({ id: 'components.card.worker.close', defaultMessage: 'Close' })}>
              <FiX />
            </button>
          )}
        </div>
        
      </div>
    );
  }
);

WorkerCard.propTypes = {
  personId: PropTypes.string.isRequired,
  className: PropTypes.string,
  score: PropTypes.shape({ votes: PropTypes.number, score: PropTypes.number }),
  price: PropTypes.shape({ currency: PropTypes.string, amount: PropTypes.number }),
  address: PropTypes.shape({ city: PropTypes.string, country: PropTypes.string }),
  experience: PropTypes.number,
  firstName: PropTypes.string,
  profilePicture: PropTypes.shape({ thumbnail: PropTypes.string, large: PropTypes.string }),
  verification: PropTypes.bool,
  lastLogin: PropTypes.number,
  isOnline: PropTypes.bool,
  personalNote: PropTypes.string,
  slug: PropTypes.string,
  showViewButton: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  showFavorite: PropTypes.bool,
  isFavorite: PropTypes.bool,
  onView: PropTypes.func,
  onFavorite: PropTypes.func,
};

WorkerCard.defaultProps = {
  className: '',
  score: {},
  price: {},
  address: {},
  experience: 0,
  firstName: '',
  profilePicture: '',
  verification: false,
  lastLogin: 0,
  isOnline: false,
  personalNote: '',
  slug: '',
  showViewButton: false,
  showCloseButton: false,
  onClose: () => {},
  showFavorite: false,
  isFavorite: false,
  onView: () => {},
  onFavorite: () => {},
};

export default WorkerCard;
